import { APIPath } from '../constant'
import { BaseService } from './base'

// Question comments (review threads, 2026-10-30). auditId / auditQuestionId / threadId are the numeric ids
// (auditQuestionId = the question's Id in the GET Inspection data = E_Audit_Questions.id).
class QuestionThreads {
    list(auditId) {
        return BaseService.get(`${APIPath.questionThreadsRoot}Inspection/${encodeURIComponent(auditId)}/Threads`)
    }

    // body { Text, Files: [{ FileKey, FileName, FileType }] } - opens, adds a reviewer comment or reopens
    comment(auditId, auditQuestionId, body) {
        return BaseService.post(
            `${APIPath.questionThreadsRoot}Inspection/${encodeURIComponent(auditId)}/Question/${encodeURIComponent(
                auditQuestionId,
            )}/Thread`,
            body,
        )
    }

    // body { Text, Files, AnswerChange?: { OptionIds?, Value? } }
    reply(threadId, body) {
        return BaseService.post(`${APIPath.questionThreadsRoot}Thread/${encodeURIComponent(threadId)}/Reply`, body)
    }

    close(threadId, body) {
        return BaseService.post(`${APIPath.questionThreadsRoot}Thread/${encodeURIComponent(threadId)}/Close`, body || {})
    }

    reopen(threadId, body) {
        return BaseService.post(`${APIPath.questionThreadsRoot}Thread/${encodeURIComponent(threadId)}/Reopen`, body)
    }

    // "review done" step: body { Note? }
    markReviewDone(auditId, body) {
        return BaseService.post(
            `${APIPath.questionThreadsRoot}Inspection/${encodeURIComponent(auditId)}/Review/Done`,
            body || {},
        )
    }

    undoReview(auditId) {
        return BaseService.post(`${APIPath.questionThreadsRoot}Inspection/${encodeURIComponent(auditId)}/Review/Undo`, {})
    }

    waitingOnMe(take = 50) {
        return BaseService.get(`${APIPath.questionThreadsWaitingOnMe}?take=${Number(take) || 50}`)
    }

    getReviewSettings(templateId) {
        return BaseService.get(APIPath.templateReviewSettings(encodeURIComponent(templateId)))
    }

    // body { ReviewFlow, AnswerChangeAllowed, ApprovalWaitsForComments, CommenterUserIds }
    saveReviewSettings(templateId, body) {
        return BaseService.post(APIPath.templateReviewSettings(encodeURIComponent(templateId)), body)
    }
}

export const QuestionThreadService = new QuestionThreads()
